import Vue from 'vue'
import store from "../store/index";
import Router from 'vue-router'
import Cookies from 'js-cookie';
// import CreatVhall from '@/views/Live-Platform/creat-vhall' // 创建直播
// import creatLubo from '@/views/Live-Platform/creat-lubo' // 创建录播
import LookLive from '@/views/Live-Platform/Look-Live' // 观看直播
import LookLiveG from '@/views/Live-Platform/Look-LiveG' // 观看直播
// import Livelist from '@/views/Live-Platform/Live-list' // 直播列表
import LiveDetail from '@/views/Live-Platform/Live-Detail' // 直播详情
// import PlanList from '@/views/Live-Platform/Plan-List' // 展会排程

import HomePage from '@/views/Home-Page' // 首页页面
import MyPurchase from '@/views/ChildPages/My-Purchase' // 我的采购
// import LookPublishing from '@/views/ChildPages/Look-Publishing' // 主推出版社——查看目录
import BookDetail from '@/views/ChildPages/Book-Detail' // 书籍推荐-书籍详情
import BookDetailSide from '@/views/ChildPages/Book-DetailSide' // 周边推荐-书籍详情

import MoreProduct from '@/views/ChildPages/More-Product' // 多元化产品
import commonLibrary from '@/views/ChildPages/common-Library' // 公共馆
import SchoolLibrary from '@/views/ChildPages/School-Library' // 高校馆
import PublisherBook from '@/views/ChildPages/Publisher-Book' // 出版社书目
import PublisherSocietys from '@/views/ChildPages/Publisher-Societys' // 百佳社书目
import PublisherNational from '@/views/ChildPages/Publisher-National' // 百佳社书目
import LocalSpot from '@/views/ChildPages/LocalSpot' // 地方版现货
import OrderOver from '@/views/ChildPages/Order-Over' // 总订单
import OrderOver1 from '@/views/ChildPages/Order-Over1' // 总订单
import OrderList from '@/views/ChildPages/Order-List' // 本次购买订单
import OrderDetail from '@/views/ChildPages/Order-Detail' // 订单详情
import BookElectron from '@/views/ChildPages/Book-Electron' // 纸电同步
import LivePhoto from '@/views/ChildPages/Live-Photo' // 现场照片
import ProductCiaabian from '@/views/ChildPages/Product-Ciaabian' // 采编一体化
import ProductTiantian from '@/views/ChildPages/Product-Tiantian.vue' // 田田阅读电子书
import ProductYun from '@/views/ChildPages/Product-Yun.vue' // 云田购
import ProductZhihui from '@/views/ChildPages/Product-Zhihui' // 智慧图书馆
import ProductFuwu from '@/views/ChildPages/Product-Fuwu' // 图书馆服务
import ProductXiaodugui from '@/views/ChildPages/Product-Xiaodugui' // 图书馆消毒柜
import ProductManual from '@/views/ChildPages/Product-Manual' // 会员手册
import ProductAI from '@/views/ChildPages/Product-AI' // AI体温检测系统
import ProductQiKan from '@/views/ChildPages/Product-QiKan' // 期刊订购
import DsfRobot from '@/views/ChildPages/Dsf-Robot' //消毒机器人
import ProductGuancang from '@/views/ChildPages/Product-Guancang' // 馆藏分析皮平台
import MajorConsortium from '@/views/ChildPages/Major-Consortium' // 专业联合体 
import PublisherChildsCoalition from '@/views/ChildPages/Publisher-ChildsCoalition' // 专业联合体下面具体的出版社
import PublisherChildsPlaces from '@/views/ChildPages/Publisher-ChildsPlaces' // 地区出版社下面具体的出版社
// import LookPublishingPagesId from '@/views/ChildPages/Look-Publishing-PagesId' // 具体出版社的ID传值的商品列表页
import LookPublishingPagesType from '@/views/ChildPages/Look-Publishing-PagesType' // 其他类型商品列表页
import LookPublishingPagesTypecopy from '@/views/ChildPages/Look-Publishing-PagesTypecopy' // 其他类型商品列表页


// import LookPaperEleBookList from '@/views/ChildPages/Look-PaperEle-BookList'   //纸电同步书目列表
import supplierdetails from '@/views/ChildPages/supplierdetails' // 供应商主页
import myRmdList from '@/views/ChildPages/myRmdList.vue'   //我的荐购
import addressmanagement from '@/views/ChildPages/addressmanagement.vue'   //地址管理

import keycommunityproportion from '@/views/ChildPages/keycommunityproportion.vue'   //重点社占比
import categoryproportion from '@/views/ChildPages/categoryproportion.vue'   //类别占比

import myBorrowRecord from '@/views/ChildPages/myBorrowRecord.vue'   //我的借阅记录
import Bookallocationrate from '@/views/Xtch/wuliumanage/Bookallocationrate.vue'   //配书率
import Bookpublishingrate from '@/views/Xtch/wuliumanage/Bookpublishingrate.vue'   //发书率
import publishingstatistics from '@/views/Xtch/wuliumanage/publishingstatistics.vue'   //发书率

import OrderDetails from '@/views/Xtch/wuliumanage/OrderDetails.vue'   //发书率


import Login from '@/views/Login/Login' // 登录
import Loginclosebeta from '@/views/Login/Loginclosebeta' // 登录

import sysmanager from './sysmanager'
import mobile, {
  pageNames
} from '../mobile/router'

import SearchList from '@/views/search/SearchList' //检索页
import SearchResult from '@/views/search/SearchResult' // 结果页
import {
  isLogin
} from '@/common/utils/user_info'

//项目进度管理
import ProjectManage from '@/views/ProjectManage/index' //
import ProblemReport from '@/views/ProjectManage/problemReport' //问题反馈

//数目提取
import getBook from '@/views/getBook/index'
import PubTop from '@/views/ChildPages/PubTop' //出版社排行
import Statistical from '@/views/ChildPages/Statistical' //统计
//导入馆藏
import ImportCol from '@/views/importCol/index'
//导入馆藏
import importENewspaper from '@/views/importENewspaper/index'
//导入书单
import ImportOrder from '@/views/importOrder/index'
//excel转Marc
import ImportMarc from '@/views/ImportMarc/index'
//excel转Marc
import externalprocurementmatching from '@/views/externalprocurementmatching/index'
//全面阅读
import qmyd from '@/views/qmyd/index'
//少儿绘本
import sehb from '@/views/qmyd/sehb'
//宣传海报
// import posters from '@/views/qmyd/posters'
//会务手册
import manual from '@/views/manual/manual'
// import test from '@/views/ChildPages/test'
//日历签到
import calendar from '@/views/ChildPages/calendar'
//收货地址
import queryAddress from '@/views/ChildPages/queryAddress'
// 我的奖品
import myPrice from '@/views/ChildPages/myPrice'
import myjieguo from '@/views/ChildPages/myjieguo'
// 全局搜索页面
import Xquery from '../views/Xtch/Xquery.vue'
import Xindex from '../views/Xtch/Xindex.vue'
import Preparationpage from "../views/Preparationpage/Preparationpage";

import Xht from '../views/Xtch/Xht.vue'





// 点击退出
function TuiClick (showjigou, store, router) {
  console.log(store, 'store');
  // 移除 Cookies
  Cookies.remove("token");
  Cookies.remove("name");
  Cookies.remove("orgName");
  Cookies.remove("UserID");
  Cookies.remove("orgGid");
  Cookies.remove("passWord");
  Cookies.remove("passPort");

  // 修改 Vuex store 中的状态
  store.commit('setLoginShowOrNot', true); // 这里假设你有一个名为 setLoginShowOrNot 的 mutation，用于修改登录状态

  // 清除本地缓存
  localStorage.removeItem("doId");
  localStorage.removeItem("user");
  // 导航到登录页面
  router.push({ name: 'Login', params: { baseid: showjigou } });

}
Vue.use(Router)

const router = new Router({
  routes: [
    // 页面
    // {
    //   path: '/',
    //   name: 'Preparationpage',
    //   component: Preparationpage,
    // },
   
    {
      path: '/',
      name: 'HomePage',
      component: HomePage
    },
     {
      path: '/Xindex',
      name: 'Xindex',
      component: Xindex,
    },
    {
      path: '/MyPurchase',
      name: 'MyPurchase',
      component: MyPurchase
    },
    // { path: '/test', name: 'test', component: test },
    {
      path: '/commonLibrary',
      name: 'commonLibrary',
      component: commonLibrary
    },
    {
      path: '/SchoolLibrary',
      name: 'SchoolLibrary',
      component: SchoolLibrary
    },
    {
      path: '/PublisherBook',
      name: 'PublisherBook',
      component: PublisherBook
    },
    {
      path: '/LocalSpot',
      name: 'LocalSpot',
      component: LocalSpot
    },
    // { path: '/LookPublishing', name: 'LookPublishing', component: LookPublishing },
    {
      path: '/BookDetail/:goodsId',
      name: 'BookDetail',
      component: BookDetail,
    },
    {
      path: '/BookDetailSide/:goodsId',
      name: 'BookDetailSide',
      component: BookDetailSide
    },
    {
      path: '/OrderOver',
      name: 'OrderOver',
      component: OrderOver
    },
     {
      path: '/OrderOver1',
      name: 'OrderOver1',
      component: OrderOver1
    },
    {
      path: '/OrderList',
      name: 'OrderList',
      component: OrderList
    },
    {
      path: '/OrderDetail',
      name: 'OrderDetail',
      component: OrderDetail
    },
    {
      path: '/MoreProduct',
      name: 'MoreProduct',
      component: MoreProduct
    },
    {
      path: '/BookElectron',
      name: 'BookElectron',
      component: BookElectron
    },
    {
      path: '/LivePhoto',
      name: 'LivePhoto',
      component: LivePhoto
    },
    {
      path: '/PublisherSocietys',
      name: 'PublisherSocietys',
      component: PublisherSocietys
    }, //百佳社
    {
      path: '/PublisherNational',
      name: 'PublisherNational',
      component: PublisherNational
    }, //国图馆三新供货地方版
    {
      path: '/ProductCiaabian',
      name: 'ProductCiaabian',
      component: ProductCiaabian
    }, // 采编一体化
    {
      path: '/ProductTiantian',
      name: 'ProductTiantian',
      component: ProductTiantian
    }, // 田田阅读
    {
      path: '/ProductYun',
      name: 'ProductYun',
      component: ProductYun
    }, // 云田购
    {
      path: '/ProductZhihui',
      name: 'ProductZhihui',
      component: ProductZhihui
    }, // 智慧图书馆
    {
      path: '/ProductFuwu',
      name: 'ProductFuwu',
      component: ProductFuwu
    }, // 图书馆服务
    {
      path: '/ProductXiaodugui',
      name: 'ProductXiaodugui',
      component: ProductXiaodugui
    }, // 图书馆消毒柜
    {
      path: '/ProductManual',
      name: 'ProductManual',
      component: ProductManual
    }, // 会务手册
    {
      path: '/ProductAI',
      name: 'ProductAI',
      component: ProductAI
    }, // AI体温检测系统
    {
      path: '/ProductQiKan',
      name: 'ProductQiKan',
      component: ProductQiKan
    }, // 期刊订购
    {
      path: '/DsfRobot',
      name: 'DsfRobot',
      component: DsfRobot
    }, // 消毒机器人
    {
      path: '/ProductGuancang',
      name: 'ProductGuancang',
      component: ProductGuancang
    }, // 期刊订购
    {
      path: '/MajorConsortium',
      name: 'MajorConsortium',
      component: MajorConsortium
    }, // 期刊订购
    {
      path: '/PublisherChildsCoalition',
      name: 'PublisherChildsCoalition',
      component: PublisherChildsCoalition
    }, //专业联合体下面具体的出版社
    {
      path: '/PublisherChildsPlaces',
      name: 'PublisherChildsPlaces',
      component: PublisherChildsPlaces
    }, // 地区出版社下面具体的出版社
    {
      path: '/LookPublishingPagesTypecopy',
      name: 'LookPublishingPagesTypecopy',
      component: LookPublishingPagesTypecopy
    }, // 其他类型商品列表页
    // { path: '/LookPublishingPagesId/:gid', name: 'LookPublishingPagesId', component: LookPublishingPagesId }, // 具体出版社的ID传值的商品列表页
    {
      path: '/LookPublishingPagesType',
      name: 'LookPublishingPagesType',
      component: LookPublishingPagesType
    }, // 其他类型商品列表页
    // { path: '/LookPaperEleBookList', name: 'LookPaperEleBookList', component: LookPaperEleBookList }, // 其他类型商品列表页
    // 直播
    // { path: '/CreatVhall', name: 'CreatVhall', component: CreatVhall },
    // { path: '/creatLubo', name: 'creatLubo', component: creatLubo },
    {
      path: '/LookLive/:webinarId',
      name: 'LookLive',
      component: LookLive
    },
    {
      path: '/LookLiveG/:webinarId',
      name: 'LookLiveG',
      component: LookLiveG
    },
    // { path: '/Livelist', name: 'Livelist', component: Livelist },
    {
      path: '/LiveDetail',
      name: 'LiveDetail',
      component: LiveDetail
    },
    // { path: '/PlanList', name: 'PlanList', component: PlanList },
    // 登录
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    // 内测登录
    {
      path: '/Loginclosebeta',
      name: 'Loginclosebeta',
      component: Loginclosebeta
    },
    // 检索
    {
      path: '/SearchList',
      name: 'SearchList',
      component: SearchList
    },
    {
      path: '/SearchResult',
      name: 'SearchResult',
      component: SearchResult
    },
    {
      path: '/ProjectManage',
      name: 'ProjectManage',
      component: ProjectManage
    },
    {
      path: '/ProblemReport',
      name: 'ProblemReport',
      component: ProblemReport
    },
    //书目提取
    {
      path: '/getBook',
      name: 'getBook',
      component: getBook
    }, //书目提取
    {
      path: '/PubTop',
      name: 'PubTop',
      component: PubTop
    }, //出版社排行
    {
      path: '/Statistical',
      name: 'Statistical',
      component: Statistical
    }, //统计
    {
      path: '/ImportOrder3',
      name: 'ImportOrder3',
      component: () => import('../views/Xtch/onlineBooklist/importOrder/index'),
      meta: {
          name: '导入订单',
      },
  },
    {
      path: '/ImportOrder',
      name: 'ImportOrder',
      component: ImportOrder
    }, //导入馆藏
    {
      path: '/ImportMarc',
      name: 'ImportMarc',
      component: ImportMarc
    }, //excel转Marc
    {
      path: '/externalprocurementmatching',
      name: 'externalprocurementmatching',
      component: externalprocurementmatching
    }, 
    {
      path: '/qmyd',
      name: 'qmyd',
      component: qmyd
    }, //全面阅读
    {
      path: '/sehb/:type',
      name: 'sehb',
      component: sehb
    }, //少儿绘本
    // { path: '/posters', name:'posters', component: posters }, //宣传海报
    {
      path: '/manual',
      name: 'manual',
      component: manual
    }, //宣传海报

    {
      path: '/calendar',
      name: 'calendar',
      component: calendar
    }, //日历签到 queryAddress
    {
      path: '/queryAddress',
      name: 'queryAddress',
      component: queryAddress
    }, //收货地址  
    {
      path: '/myPrice',
      name: 'myPrice',
      component: myPrice
    }, //我的奖品
    {
      path: '/myjieguo',
      name: 'myjieguo',
      component: myjieguo
    }, //我的奖品
    {
      path: '/supplierdetails',
      name: 'supplierdetails',
      component: supplierdetails
    }, //供应商主页
    {
      path: '/Xquery',
      name: 'Xquery',
      component: Xquery
    }, //我的荐购
    {
      path: '/myRmdList',
      name: 'myRmdList',
      component: myRmdList
    },
    // 地址管理
    {
      path: '/addressmanagement',
      name: 'addressmanagement',
      component: addressmanagement
    }, 
    //我的借阅记录
    {
        path: '/myBorrowRecord',
        name: 'myBorrowRecord',
        component: myBorrowRecord
      }, 
    
    //供应商主页
    {
      path: '/Xht', name: 'Xht', component: Xht,
      redirect: '/shoppingList',
      children: [{
          path: '/shoppingList',
          name: 'shoppingList',
          component: () => import('../views/Xtch/onlineBooklist/shoppinglist.vue'),
          meta: {
            name: '购物车汇总',
          },
        },{
          path: '/orderListSet',
          name: 'orderListSet',
          component: () => import('../views/Xtch/onlineBooklist/orderlist.vue'),
          meta: {
            name: '订单汇总',
          },
        },{
          path: '/purchaserecord',
          name: 'purchaserecord',
          component: () => import('../views/Xtch/onlineBooklist/purchaserecord.vue'),
          meta: {
            name: '采购记录',
          },
        },
        
        {
            path: '/ImportOrder2',
            name: 'ImportOrder2',
            component: () => import('../views/Xtch/onlineBooklist/importOrder/index'),
            meta: {
                name: '导入订单',
            },
        },
       
        {
          path: '/importOrdertuihuo',
          name: 'importOrdertuihuo',
          component: () => import('../views/Xtch/onlineBooklist/importOrdertuihuo/index'),
          meta: {
              name: '退货订单',
          },
      },
        
        {
            path: '/orderlistDetail',
            name: 'orderlistDetail',
            component: () => import('../views/Xtch/onlineBooklist/orderlistdetail'),
            meta: {
                name: '订单详情',
            },
        },{
          path: '/jgcl',
          name: 'jgcl',
          component: () => import('../views/Xtch/jgManage/jgcl.vue'),
          meta: {
            name: '荐购处理',
          },
        },
        {
            path: '/jgOrderList',
            name: 'jgOrderList',
            component: () => import('../views/Xtch/jgManage/jgOrderlist.vue'),
            meta: {
                name: '荐购订单汇总',
            },
        },{
              path: '/jgOrderDetail',
              name: 'jgOrderDetail',
              component: () => import('../views/Xtch/jgManage/jgOrderDetail.vue'),
              meta: {
                name: '荐购订单详情列表',
              },
        },{
          path: '/jgclcopy',
          name: 'jgclcopy',
          component: () => import('../views/Xtch/jgManage/jgclcopy.vue'),
          meta: {
            name: '荐购处理',
          },
        },
        {
          path: '/jgjl',
          name: 'jgjl',
          component: () => import('../views/Xtch/jgManage/jgjl.vue'),
          meta: {
            name: '一般荐购记录',
          },
        },
        {
          path: '/jgjlcopy',
          name: 'jgjlcopy',
          component: () => import('../views/Xtch/jgManage/jgjlcopy.vue'),
          meta: {
            name: '荐购直邮记录',
          },
        },
        {
          path: '/jgsd',
          name: 'jgsd',
          component: () => import('../views/Xtch/jgManage/jgsd.vue'),
          meta: {
            name: '荐购规则',
          },
        },
        {
          path: '/jgzysd',
          name: 'jgzysd',
          component: () => import('../views/Xtch/jgManage/jgzysd.vue'),
          meta: {
            name: '荐购直邮规则',
          },
        },
        {
          path: '/jgzypz',
          name: 'jgzypz',
          component: () => import('../views/Xtch/jgManage/jgzypz.vue'),
          meta: {
            name: '荐购直邮配置',
          },
        },
        {
          path: '/platform-config',
          name: 'PlatformConfig',
          component: () => import('../views/Xtch/systemSet/index.vue'),
          meta: { name: '平台配置' }
        },
        // 新增的3个功能子页面
        {
          path: '/basic-rule',
          name: 'BasicRuleSetting',
          component: () => import('../views/Xtch/systemSet/BasicRuleSetting.vue'),
          meta: { name: '基础规则设置' }
        },
        {
          path: '/business-config',
          name: 'BusinessConfig',
          component: () => import('../views/Xtch/systemSet/BusinessConfig.vue'),
          meta: { name: '业务参数配置' }
        },
        {
          path: '/system-docking',
          name: 'SystemDocking',
          component: () => import('../views/Xtch/systemSet/SystemDocking.vue'),
          meta: { name: '系统对接管理' }
        },
        {
          path: '/publishingstatisticss',
          name: 'publishingstatisticss',
          component: () => import('../views/Xtch/publishingstatisticss/publishingstatisticss.vue'),
          meta: {
            name: '发书统计',
          },
        },
        {
          path: '/userManage',
          name: 'userManage',
          component: () => import('../views/Xtch/userManage/index.vue'),
          meta: {
            name: '用户管理',
          },
        },
        {
          path: '/bookManage',
          name: 'bookManage',
          component: () => import('../views/Xtch/bookManage/index.vue'),
          meta: {
            name: '书目管理',
          },
        },{
          path: '/classificationmanagement',
          name: 'classificationmanagement',
          component: () => import('../views/Xtch/classificationmanagement/index.vue'),
          meta: {
            name: '分类管理',
          },
        },
        
        {
          path: '/publishinghouseManage',
          name: 'publishinghouseManage',
          component: () => import('../views/Xtch/publishinghouseManage/index.vue'),
          meta: {
            name: '出版社管理',
          },
        },
        {
          path: '/noBooklist',
          name: 'noBooklist',
          component: () => import('../views/Xtch/noBooklist/index.vue'),
          meta: {
            name: '无书目荐购',
          },
        },
        {
          path: '/borrowManage',
          name: 'borrowManage',
          component: () => import('../views/Xtch/borrowManage/index.vue'),
          meta: {
            name: '借阅管理',
          },
        },
        {
          path: '/borrowManaget',
          name: 'borrowManaget',
          component: () => import('../views/Xtch/borrowManaget/index.vue'),
          meta: {
            name: '借购管理',
          },
        },
        {
          path: '/referenceorder',
          name: 'referenceorder',
          component: () => import('../views/Xtch/referenceorder/index.vue'),
          meta: {
            name: '借购管理',
          },
        },
        {
          path: '/libRank',
          name: 'libRank',
          component: () => import('../views/Xtch/libRank/index.vue'),
          meta: {
            name: '图书馆访问统计',
          },
        },
        {
          path: '/Bookallocationrate',
          name: 'Bookallocationrate',
          component: Bookallocationrate,
          meta: {
            name: '配书率',
          },
        },
        {
          path: '/keycommunityproportion',
          name: 'keycommunityproportion',
          component: keycommunityproportion,
          meta: {
            name: '重点社占比',
          },
        },
         {
          path: '/categoryproportion',
          name: 'categoryproportion',
          component: categoryproportion,
          meta: {
            name: '类别占比',
          },
        },
        
        {
          path: '/Bookpublishingrate',
          name: 'Bookpublishingrate',
          component: Bookpublishingrate,
          meta: {
            name: '发书率',
          },
        },
        {
          path: '/publishingstatistics',
          name: 'publishingstatistics',
          component: publishingstatistics,
          meta: {
            name: '发书统计',
          },
        },
        {
          path: '/OrderDetails',
          name: 'OrderDetails',
          component: OrderDetails,
        },
        {
          path: '/ImportCol',
          name: 'ImportCol',
          component: ImportCol,
          meta: {
            name: '馆藏导入',
          },
        }, //导入馆藏
        {
          path: '/importENewspaper',
          name: 'importENewspaper',
          component: importENewspaper,
          meta: {
            name: '电子报订上传',
          },
        }, //导入馆藏
      ]
    },//后台
    {
      path: '/:baseid', // 将路由路径修改为 '/jc:baseid'
      name: 'Xindextwo',
      component: Xindex
    },

    // 管理页面
    sysmanager,
    // 移动端 先集成在web端中
    ...mobile.routes
  ],
  scrollBehavior (to, from, savedPosition) {
    // 从二级页面返回首页时,savedPosition会存在,此时直接返回savedPosition所在的微信,其他没有savedPosition的时候都滚动到头部
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})
router.beforeEach((to, from, next) => {
  const routeName = to.name;
  const toPath = to.fullPath; // 获取用户即将进入的地址栏地址
  // if(routeName ==='Preparationpage'){
  //   next()
  // }
  // else
   if (routeName === 'Xindex') {
    next(); 
  }
  else if (routeName === 'Loginclosebeta') {
    next(); 
  }
  else if (routeName === 'HomePage') {
    next(); 
  }
  else if (routeName === 'Xindextwo' && Object.keys(to.query).length > 0 && to.query.key !=1) {
    // 用户进入了带参数的首页
    if (to.params.baseid) {
      let result = toPath.substring(1);
      localStorage.setItem('showjigou', result);
      // 检查用户是否已登录
      const user = localStorage.getItem('user');
      if (user != null) {
        const showjigou = localStorage.getItem('showjigou');
        const userJSON = localStorage.getItem('user');
        if (userJSON) {
          const users = JSON.parse(userJSON);
          if (users && users.orgCode) {
            if (showjigou == users.orgCode) {
            } else {
              if (to.name != 'login') {
                TuiClick(showjigou, store, router);
              }
            }
          }
        }
      } else {
        if (to.name !== 'login') {
        //   console.log('如果用户未登录，并且当前页面不是登录页面，则重定向到登录页面');
          //   next('/login'); // 重定向到登录页
        }
      }

    }
    next();
  } 
  else {
    // 用户进入了其他页面
    // 检查用户是否已登录
    if (to.name !== 'Login') {
        const user = localStorage.getItem('user');
        if(user){
            next();
        }else{
            // console.log('如果用户未登录，并且当前页面不是登录页面，则重定向到登录页面');
            if(to.query.key ==1){
              next()
            }else{
              next({name:'Login'});
            }
            
        }
    }else{
        next();
    }
  }
  const mStyleId = 'g_m_style'
  const pageName = to.name
  if (pageName && pageName.indexOf('m_') !== -1) {
    // 插入m版需要css
    let style = document.getElementById(mStyleId)
    if (!style) {
      const mCss = `@charset "UTF-8";*{-webkit-tap-highlight-color:rgba(0,0,0,0);outline:0}*,blockquote,body,button,dd,dl,dt,fieldset,form,h1,h2,h3,h4,h5,h6,hr,input,legend,li,ol,p,pre,td,textarea,th,ul{margin:0;padding:0;vertical-align:baseline}img{border:0 none;vertical-align:top}em,i{font-style:normal}ol,ul{list-style:none}button,h1,h2,h3,h4,h5,h6,input,select{font-size:100%;font-family:inherit}table{border-collapse:collapse;border-spacing:0}a{text-decoration:none}a,body{color:#666}body{margin:0 auto;min-width:20pc;max-width:40pc;height:100%;font-size:14px;font-family:Helvetica,STHeiti STXihei,Microsoft JhengHei,Microsoft YaHei,Arial;line-height:1.5;-webkit-text-size-adjust:100%!important;-ms-text-size-adjust:100%!important;text-size-adjust:100%!important;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background:#f9f9f9}input[type=text],textarea{-webkit-appearance:none;-moz-appearance:none;appearance:none}.el-message-box{width:280px!important}.toast_custom_class{min-width:100px;max-width:300px}.el-message-box__message{max-height:200px;overflow-y:auto;-webkit-overflow-scrolling:touch}`
      style = document.createElement('style')
      style.id = mStyleId
      style.type = ''
      style.innerHTML = mCss
      const body = document.getElementsByTagName('body')[0]
      if (body) {
        body.appendChild(style)
      }
    }

    // 不需要登录态的页面
    const noLoginPages = [pageNames.preparationpage, pageNames.login]
    if (!isLogin() && !noLoginPages.includes(pageName)) {
      // 将要访问的页面与参数传到登录页面，登录成功后再继续跳转
      return next({
        name: pageNames.login,
        query: {
          toPage: pageName,
          params: JSON.stringify(to.params),
          query: JSON.stringify(to.query)
        }
      })
    }
  } else {
    const mStyle = document.getElementById(mStyleId)
    mStyle && mStyle.remove()
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js